import { create } from 'zustand';
import translations from './translations';
import type { Locale } from './translations';

interface I18nState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string) => string;
}

function detectLocale(): Locale {
  // Check localStorage first (user preference)
  const saved = localStorage.getItem('locale');
  if (saved === 'en' || saved === 'es') return saved;

  // Detect from browser
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  const lang = browserLang.toLowerCase();

  // Spanish variants: es, es-ES, es-MX, es-AR, etc.
  if (lang.startsWith('es')) return 'es';

  return 'en';
}

export const useI18n = create<I18nState>((set, get) => ({
  locale: detectLocale(),

  setLocale: (locale: Locale) => {
    localStorage.setItem('locale', locale);
    set({ locale });
  },

  t: (key: string) => {
    const { locale } = get();
    return translations[locale]?.[key] || translations['en']?.[key] || key;
  },
}));